export const DEVICE = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
} as const;

export const { MOBILE, TABLET, DESKTOP } = DEVICE;

export type DeviceType = (typeof DEVICE)[keyof typeof DEVICE];

export function useScreenSize() {
  const device = ref<DeviceType>(DESKTOP);

  const setDevice = (width: number) => {
    device.value = width < 768
      ? MOBILE
      : width <= 1024
      ? TABLET
      : DESKTOP;
  };

  const updateDeviceTypeBasedOnWindow = () => {
    if (typeof window === 'undefined') return;
    setDevice(window.innerWidth);
  };

  if (import.meta.client) {
  onMounted(() => {
    updateDeviceTypeBasedOnWindow();
    window.addEventListener('resize', updateDeviceTypeBasedOnWindow, { passive: true }); // Use passive for performance
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateDeviceTypeBasedOnWindow);
  });
  }

  return {
    device,
    isMobileScreen: computed(() => device.value === MOBILE),
    isTabletScreen: computed(() => device.value === TABLET),
    isDesktopScreen: computed(() => device.value === DESKTOP),
  };
}